<template>
  <div>
    <img :src="OurStory" alt="" width="100%">
  </div>
</template>

<script>
  import card from '@views/general/modules/Card.vue'

  export default {
    name: 'OurStory',
    components: { card },
    props: {
      OurStory: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },
    methods: {
      initData() {
      },
      loadData() {
      }
    }
  }
</script>

<style lang="less" scoped></style>
